export const loadScript = url => {
  let tag = document.createElement('script');
  tag.src = url;
  tag.async = true;
  let firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
};
